/**
 * @typedef LogicalOperatorsEnum
 * @type {Readonly<{AND: string, OR: string, NOT: string}>}
 */
export const LogicalOperatorsEnum = Object.freeze({
  AND: "AND",
  OR: "OR",
  NOT: "NOT",
});
